import React from 'react'
import { CircularProgress } from '@material-ui/core'

export const ButtonLoader =
  ({text}: {text: string}) =>
    <>
      <CircularProgress size={20} style={{marginRight: 10}}/>
      {text}
    </>